<ui-card>
    <label class="font-medium">{{ 'time-off-v3.general-settings-edit.employeeVisibility' | translate }}</label>
    <div class="flex middle margin-bottom-3 margin-top-2">
        <mat-radio-group
            class="margin-right-2 margin-top-1 vertical"
            [ngModel]="timeOffVisibility"
            (ngModelChange)="timeOffVisibilityChange($event)"
        >
            <mat-radio-button [value]="true">{{
                'time-off-v3.general-settings-edit.employeeVisibilityYes' | translate
            }}</mat-radio-button>
            <mat-radio-button class="margin-top-2" [value]="false">
                {{ 'time-off-v3.general-settings-edit.employeeVisibilityNo' | translate }}</mat-radio-button
            >
        </mat-radio-group>
    </div>

    <div class="margin-top-4">
        <label class="font-medium">{{ 'time-off-v3.general-settings-edit.dateTimeOffTypes' | translate }}</label>
        <div class="flex align-items-baseline margin-top-2">
            <mat-radio-group
                class="margin-right-2 vertical"
                [ngModel]="timeOffBalanceDateToday"
                (ngModelChange)="timeOffBalanceDateTodayChange($event)"
            >
                <mat-radio-button [value]="true">{{ 'time-off-v3.today' | translate }}</mat-radio-button>
                <mat-radio-button class="margin-top-2" [value]="false">
                    {{
                        'time-off-v3.policyComponents.settings.general-settings.yearEndHasTimeOffBalance' | translate
                    }}</mat-radio-button
                >
            </mat-radio-group>
        </div>
    </div>

    <div class="margin-top-4">
        <label>{{ 'time-off-v3.general-settings-edit.backupApprover' | translate }}</label>
        <div class="align-items-baseline margin-top-1 responsive-grid">
            <div class="row w-50 align-items-center">
                <mat-form-field class="no-labels no-helpers">
                    <mat-select
                        [ngModel]="selectedBackupApprover"
                        name="timeOffBackupApprover"
                        #timeOffBackupApprover
                        placeholder="{{ 'time-off-v3.allActiveAdmins' | translate }}"
                        (selectionChange)="updateBackupApprover($event)"
                        required
                    >
                        <mat-option [value]="0">{{ 'time-off-v3.allActiveAdmins' | translate }}</mat-option>
                        <mat-option [value]="admin.id" *ngFor="let admin of activeAdmins">
                            {{ admin.fullName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <a
                    href="https://humi.zendesk.com/hc/en-us/articles/4411058160151"
                    class="font-medium"
                    (click)="trackLearnMoreBackupApprover()"
                    target="_blank"
                    >{{ 'time-off-v3.learnMoreAboutBackupApprovers' | translate }}
                </a>
            </div>
        </div>
    </div>
</ui-card>
